export const RESET = 'MODULE_LIST_RESET'
export const SET_ITEMS = 'MODULE_LIST_SET_ITEMS'
export const SET_ERROR = 'MODULE_LIST_SET_ERROR'
export const SET_VIEW = 'MODULE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'MODULE_LIST_TOGGLE_LOADING'
